module.exports = __webpack_public_path__ + "img/swiper_3.0_5_2.0f427665.webp";